import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { AuthenticationService } from '../shared/index';
import { MatDialog } from '@angular/material/dialog';
import { DataService } from '../shared/data.service';
import { RuckitForgotPasswordDialogComponent } from '../shared/forgot-password-dialog/forgot-password-dialog.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'my-login',
  templateUrl: 'login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit {
  model: any = {};
  loading = false;
  noLocalStorage = false;
  errors: any[] = [];
  returnUrl: any;
  returnParams!: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private dataService: DataService,
    private authenticationService: AuthenticationService,
    private translate: TranslateService,
    public forgotPasswordDialog: MatDialog
  ) {}

  ngOnInit() {
    // reset login status
    this.authenticationService.logout();
    this.route.queryParams.subscribe((params: Params) => {
      if (params['returnUrl'] && params['returnUrl'].length) {
        const urlParts = params['returnUrl'].split('?');
        this.returnUrl = urlParts[0];
        this.returnParams = urlParts[1];
      }
    });

    try {
      localStorage.setItem('localStorage', '1');
    } catch (e) {
      this.noLocalStorage = true;
      this.errors.push(this.translate.instant('This website does not support mobile browsers in Private Browsing mode.'));
    }
  }

  login() {
    this.loading = true;
    this.errors = [];
    this.authenticationService.login(this.model.email, this.model.password)
      .subscribe(result => {
        if (result === true) {
          this.dataService.changeData({ authenticated: result });
          this.loading = false;
          if (this.returnUrl && this.returnUrl.length && this.returnUrl !== '/logout' && this.returnUrl !== '/') {
            this.router.navigate([this.returnUrl]);
          } else {
            this.router.navigate(['/tickets']);
          }
        } else {
          this.errors.push(this.translate.instant('Email or password is incorrect'));
          this.loading = false;
        }
      }, () => {
        this.loading = false;
        this.errors.push(this.translate.instant('Email or password is incorrect'));
      });
  }

  logout() {
    this.loading = true;
    this.authenticationService.logout();
    this.loading = false;
    this.router.navigate(['/login']);
  }

  forgotPassword() {
    const dialogRef = this.forgotPasswordDialog.open(RuckitForgotPasswordDialogComponent, {
      width: '444px'
    });
    dialogRef.componentInstance.model = Object.assign({}, this.model);
    dialogRef.afterClosed().subscribe();
  }
}
